export const createThumbnailPreview = (progressContainer) => {
    const thumbnailPreview = document.createElement('div');
    thumbnailPreview.style.cssText = `
        position: absolute;
        bottom: 25px;
        background: rgba(0,0,0,0.9);
        border: 2px solid white;
        border-radius: 4px;
        padding: 4px;
        display: none;
        z-index: 1000;
        pointer-events: none;
    `;
    
    const thumbnailImg = document.createElement('img');
    thumbnailImg.style.cssText = 'width: 160px; height: 90px; display: block;';
    
    const thumbnailTime = document.createElement('div');
    thumbnailTime.style.cssText = 'color: white; text-align: center; font-size: 12px; margin-top: 4px;';
    
    thumbnailPreview.appendChild(thumbnailImg);
    thumbnailPreview.appendChild(thumbnailTime);
    progressContainer.appendChild(thumbnailPreview);

    return { thumbnailPreview, thumbnailImg, thumbnailTime };
};

export const setupThumbnailHover = (progressContainer, progressTrack, thumbnails, thumbnailPreview, thumbnailImg, thumbnailTime, player, isLiveStream) => {
    progressContainer?.addEventListener('mousemove', (e) => {
        if (!isLiveStream(player)) {
            const rect = progressTrack.getBoundingClientRect();
            const percent = (e.clientX - rect.left) / rect.width;
            const duration = player.duration();
            
            if (duration && duration > 0) {
                const time = Math.floor(percent * duration);
                const thumbnail = thumbnails.find(t => time >= t.time && time < t.time + 5) || thumbnails[0];
                
                if (thumbnail) {
                    console.log('Showing thumbnail for time:', time);
                    thumbnailImg.src = thumbnail.url;
                    thumbnailTime.textContent = `${Math.floor(time / 60)}:${(time % 60).toString().padStart(2, '0')}`;
                    thumbnailPreview.style.display = 'block';
                    thumbnailPreview.style.left = `${e.clientX - rect.left - 80}px`;
                }
            }
        }
    });

    progressContainer?.addEventListener('mouseleave', () => {
        console.log('Hiding thumbnail');
        thumbnailPreview.style.display = 'none';
    });
};
